import { FormControl } from "@angular/forms";
import { Injectable } from "@angular/core";
import { BaseSearchForm } from "../../shared/forms/base-search.form";
import { RegistryApiService } from "../../shared/services/registry-api.service";
import { PageResult } from "../../shared/models/page-result.model";
import { Event } from "../../shared/models/event.model"; 
import { TrainingProviderEventSortFieldAndDirection } from "../../shared/enums/training-provider-event-sort-field-and-direction.enum";

@Injectable({ providedIn: 'root' })
export class EventSearchForm extends BaseSearchForm<Event> {

  public previousDaysPastEvent: boolean;

  public readonly enumPrefix: string = 'trainingProviderEventSort';
  public sortOptions: Array<{ name: string, value: number }> = [];

  public controls = {
    courseName: new FormControl<string>(''),
    eventId: new FormControl<number | null>(null),
    showFutureEvents: new FormControl<boolean>(false),
    pageNumber: new FormControl<number>(this.currentPage),
    pageSize: new FormControl<number>(this.pageSize),
    sortFieldAndDirection: new FormControl<number>(TrainingProviderEventSortFieldAndDirection.EventIdAscending)
  };
  
  constructor(
    private registryApiService: RegistryApiService
  ) {
    super(true);
    this.setupBaseFormNoReset();
    this.initSortData();
    
    this.controls.courseName.setValue(this.getFromSessionStorage('eventSearchCourseName') || '');
    if (sessionStorage.getItem('eventSearchEventId') !== null) {
      this.controls.eventId.setValue(parseInt(this.getFromSessionStorage('eventSearchEventId')!));
    }
    this.controls.showFutureEvents.setValue(this.getFromSessionStorage('eventSearchshowFutureEvents') === 'true');
    this.previousDaysPastEvent = this.controls.showFutureEvents.value!;
    this.search();
  };

  protected override fetchServiceFunction(params: { [key: string]: unknown; }): Promise<PageResult<Event>> {
    return this.registryApiService.getEvents(params);
  };

  protected initSortData = (): void => {
    this.sortOptions = Object.keys(TrainingProviderEventSortFieldAndDirection)
      .filter(key => isNaN(+key))
      .map(key => {
        return {
          name: this.enumPrefix + key,
          value: TrainingProviderEventSortFieldAndDirection[key as keyof typeof TrainingProviderEventSortFieldAndDirection]
        };
      });
  }

  public override search(): Promise<void>  {
    return super.search();
  };

  private getFromSessionStorage(key: string): string|null  {
    var ret: string | null = sessionStorage.getItem(key);
    if (ret!=null) {
          sessionStorage.removeItem(key);
    }
    return ret;
  };
}
